import React, { Component, PropTypes } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom'
import { Field, reduxForm } from 'redux-form';

const fields = [ 'firstName', 'lastName', 'phone' ];

const StudentProfileForm = props => {
  console.log("going to render student profile form");
  console.log(props);
  const { fields: { firstName, lastName, phone }, handleSubmit, pristine, load, reset, submitting } = props;
  return (
    <div>
      <div className="profile-form-container">
        <div className="email-display">Email: {props.initialValues.email}</div>
        <form onSubmit={handleSubmit}>
          <Field className="form-field" name="firstName" placeholder="First Name" component="input" type="text" value={props.initialValues.firstName}/><br/>
          <Field className="form-field" name="lastName" placeholder="Last Name" component="input" type="text" value={props.initialValues.lastName}/><br/>
          <Field className="form-field" name="phone" placeholder="phone number" component="input" type="text" value={props.initialValues.phone}/><br/><br/>
          <br/><br/>
          <button type="submit" className="register-button"> Update </button>
          </form>
      </div>
    </div>
  )
}

StudentProfileForm.propTypes = {
  fields: PropTypes.array.isRequired,
//  load: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
//  resetForm: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired
}

export default reduxForm({
  form: 'profile-form-container',
  fields,
  enableReinitialize: true
})(StudentProfileForm);



// WEBPACK FOOTER //
// ./src/components/dashboards/StudentProfileForm.js